import { isEmpty, isUndefined } from 'lodash'
import { AvailabilitiesPeriod } from '../types'

export const isCurrentPeriodEmpty = (period: AvailabilitiesPeriod) => {
  return (
    isEmpty(period) ||
    Object.values(period).every((v) => isEmpty(v)) ||
    Object.values(period).every((week) => week.every((day) => isEmpty(day.availabilities)))
  )
}
export const isCurrentPeriodUndefined = (period: AvailabilitiesPeriod) =>
  Object.values(period).every((value) => isUndefined(value))
